import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  private routeSubscription: Subscription;
  constructor(private router: Router, private authService: AuthService) {
    this.routeSubscription = this.router.events.subscribe( event => {
      if (event instanceof NavigationEnd) {
        this.authService.logout();
      }
    });
   }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }


}
